// extracted by mini-css-extract-plugin
module.exports = {"container":"Skeleton_container__3O4z4"};